import { setPagination } from '../../../State/pagination';
import fetchItemDescriptions from '../../../Services/fetchItemDescriptions';

export default (pagination) => async (dispatch) => {

  window.scrollTo(0, 0);

  dispatch(setPagination(pagination));
  
  await dispatch(fetchItemDescriptions());

}